<template>
  <element>
    <el-row>
      <el-col>

          <panel :label="'抵押物'+(idx+1)"  v-for="(item, idx) in houseData.properties" :key="idx" >
              <panel label="房屋信息">
                  <div v-for="(itemP, idxP) in item.pr__owners" :key="idxP">
                      <form-build
                          :form-data="itemP"
                          :form-rules="fangRulesP"
                          :form-columns="houseColumnsP"
                          class="formTable"
                      />
                      <br/>
                      <br/>
                  </div>
                  <form-build
                      :form-data="item"
                      :form-rules="customerRules"
                      :form-columns="houseColumns"
                      class="formTable"
                  />
              </panel>
              <panel label="资产证明" class="zhengjianxinxi">
                  <photo-browser v-model="item.pr__propertyCert" type='img' label="房产证"/>
                  <photo-browser v-model="item.pr__propertyLand" type='img' label="土地证"/>
                  <photo-browser v-model="item.pr__propertyLogbook" type='img' label="产调"/>
              </panel>
              <data-table
                  :table-data="{data:item.pr__values, propertyIdx:idx}"
                  :columns="columns"
                  :page.sync="page"
                  :filters.sync="filters"
                  :actions="actions"
                  :isPaginationShow="false"
                  ref="tableForm"
              />
              <div class="totalltxt tr of">
                  平均值： {{pjdjArr[idx]|formatMoney}}
              </div>
              <form-build
                  :form-data.sync="item"
                  :form-rules="customerRules2"
                  :form-columns="asmColumns2"
                  class="formTable"
              />
          </panel>
      </el-col>
      <el-col>
      </el-col>
    </el-row>
  </element>
</template>

<script>
  import sexOptions from '../../utils/sexOptions'
  import {getImageUrl} from '../../filters/CommonActions'
  import {formatMoney} from "../../filters/CommonFilters";
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import Constant from "../../utils/constant";
  export default {
    name: "CustomerDetailComponent",
    data() {
      return {
          houseColumnsP:[
              {
                  label: '姓名',
                  field: 'ow__ownerName',

              },
              {
                  label: '身份证号',
                  field: 'ow__ownerIC',

              },
              {
                  label: '手机号',
                  field: 'ow__ownerContactNo',
                  span:24
              },
              {
                  label: '住所地址',
                  field: 'ow__ownerAddress',
                  span:24
              },
          ],
        houseColumns:[
          /*{
            label: '权属',
            field: 'pr__propertyOwner',
          },*/
            {
                label: '用途',
                field: 'pr__propertyUsage',
            },
          {
            label: '位置',
            field: 'pr__propertyLocation',
          },
            {
                label: '产权证号',
                field: 'pr__propertyCertNo',
            },
          {
            label: '面积',
            field: 'pr__propertyArea',
            unit:'㎡'
          },
        {
            label: '土地使用权面积',
            field: 'pr__propertyLandArea',
            unit:'㎡'
        },

          {
            label: '土地证',
            field: 'pr__propertyLandNo',
          },
        ],
          columns:[
              {
                  label: '序号',
                  type: 'index'
              },
              {
                  label: '查询渠道',
                  field: 'pv__source',
              },
              {
                  label: '挂牌单价',
                  field: 'pv__quote',

                  unit:'元/㎡',
              },
          ],
          page: 1,
          pageSize: 20,
          actions: [

          ],
          filters: {
              form: {

              },
              columns: [

              ]
          },
          customerRules:{},
          fangRulesP:{},
          customerRules2:{},
          asmColumns2:[
              {
                  label: '评估单价',
                  field: 'asm__assessedUnitValue',
                  formatter: function (c,v) {
                      return formatMoney(v)
                  },
                  unit:'元/㎡'
              },
              {
                  label: '实际评估价',
                  field: 'asm__assessedTotalValue',
                  formatter: function (c,v) {
                      return formatMoney(v)
                  },
                  unit:'元'
              },
              {
                  label: '名义评估价',
                  field: 'asm__nominalTotalValue',
                  formatter: function (c,v) {
                      return formatMoney(v)
                  },
                  unit:'元',
                  span:24
              },
              {
                  label: '名义评估价说明',
                  field: 'asm__nominalValueRemarks',
                  span:24
              },
              {
                  label: '抵押顺位',
                  field: 'asm__pledgeGrade',

              },
              {
                  label: '抵押率',
                  field: 'asm__pledgeRate',
                  unit:'%'
              },
              {
                  label: '一抵余额',
                  field: 'asm__pledgeExAmount',
                  formatter: function (c,v) {
                      return formatMoney(v)
                  },
                  unit:'元',
              },
              {
                  label: '一抵债权金额',
                  field: 'asm__pledgeRightsAmount',
                  formatter: function (c,v) {
                      return formatMoney(v)
                  },
                  unit:'元',
              },
              {
                  label: '产调情况',
                  field: 'asm__pledgeRemarks',

                  span:24

              },

          ],
      }
    },
    props: {
      value: {
        type: Object
      },
      isShowPic1: {
        Boolean,
        default: false
      }
    },
    computed: {
        pjdjArr() {
            return this.houseData.properties.map(item=> {
                //  console.log(item)
                let tempArr = item.pr__values.filter(item=>item.pv__quote)

                return tempArr.reduce((total, curr) => {
                    total = (Number(curr.pv__quote)||0) + Number(total)
                    return total
                }, 0)/tempArr.length
            })
        },
      houseData: {
        get: function () {
          return this.value
        },
        set: function (newVal) {
          this.$emit('input', newVal)
        }
      }
    },
    filters: {
      getImageUrl,
      sex2CN: function (sex) {
        let sexItem = sexOptions.filter(item=>item.value==sex).shift()||[]
        return sexItem.label||''
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/CustomerHouseFangComponent.vue